import { render, staticRenderFns } from "./azteclegend.vue?vue&type=template&id=1d84bc38&scoped=true"
import script from "./azteclegend.vue?vue&type=script&lang=js"
export * from "./azteclegend.vue?vue&type=script&lang=js"
import style0 from "./azteclegend.vue?vue&type=style&index=0&id=1d84bc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84bc38",
  null
  
)

export default component.exports